<template>
  <div>
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-dark">
        <!-- Insert Image Here -->
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto"></div>
          <div class="col-lg-6 order-lg-1">
            <div class="pl-0">
              <h4 class="display-3 text-white">Our Ministries</h4>
              <p class="text-white">
                Our ministries are driven by spiritual gifts, centered on the gospel of
                Christ, and devoted to God's glory.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Men's Ministry -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Men’s Ministry</h2>
            <p class="lead">
              The Men's Ministry is an important force in the OBCM Church, dedicated to
              equipping men for leadership in preaching, teaching, discipleship, and
              pastoral care. The ministry fosters spiritual growth, biblical
              understanding, and leadership development, ensuring that men are prepared to
              serve the local congregation.
            </p>

            <p class="lead">
              Through mentoring relationships and theological training, men are
              strengthened and empowered for effective gospel ministry. At the heart of
              the ministry is a commitment to the Word of God as it trains men in biblical
              teaching, leads small group learning, and mentors young men, offering
              biblical wisdom and support.
            </p>

            <p class="lead">
              The ministry also leads and partners with other men from the OBCM
              Association in hands-on ministry experiences like church planting,
              evangelical missions, church building construction and repair, ensuring that
              ministry practices are applied in real-world settings while building strong
              Christ-centered communities.
            </p>

            <img
              v-lazy="'img/ministries/men-ministry.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Men's Ministry"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Women's Ministry -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Women’s Ministry</h2>
            <p class="lead">
              The Women's Group is a ministry that provides an environment for women that
              encourages them to establish a deep personal relationship with God. It seeks
              to address women's spiritual struggles and difficulties and provides
              guidance that's spiritually anchored in God's Word and grounded in the
              divine enlightenment of the Holy Spirit.
            </p>

            <p class="lead">
              This ministry continues to pray for women to discover their God-given gifts
              and utilize them for God's service.
            </p>

            <p class="lead">
              Women passionately serve through the opportunities opened by God, such as
              Sunday school group mentoring, ushering in Lord Supper and Sunday services,
              prayer, food service through Pantry Ministry, Saturday Bible School as
              volunteer teachers, C2C Women Mentoring, worship leading, fund raising and
              solicitation for ministry support. This servanthood ministry strives to
              honor God.
            </p>

            <p class="lead">
              Ephesians 2:10
              <i
                >"For we are his workmanship, created in Christ Jesus for good works,
                which God prepared beforehand, that we should walk in them."</i
              >.
            </p>

            <img
              v-lazy="'img/ministries/women-ministry.JPG'"
              class="img-fluid rounded shadow mt-4"
              alt="Women's Ministry"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Children's Ministry -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Children's Ministry</h2>
            <p class="lead">
              The Children’s Ministry of OBCM prays to provide a safe, nurturing
              environment where children can grow in their understanding of God’s Word and
              develop a deep, personal relationship with Jesus Christ. Rooted in the
              Biblical tradition, the ministry emphasizes the sovereignty of God, the
              authority of Scripture, and the Gospel of Christ, ensuring that children not
              only hear the gospel but also learn the foundational truths of Christian
              faith. Through age-appropriate Bible lessons, worship songs, and interactive
              activities, children are encouraged to apply biblical principles in their
              everyday lives, building a solid spiritual foundation that will guide them
              as they grow.
            </p>

            <p class="lead">
              In addition to teaching sound doctrine, the Children’s Ministry fosters a
              sense of community, where children are supported by loving, trained
              volunteers who model Christlike behavior. The ministry includes Sunday
              school classes, Saturday bible school (online), and seasonal events like
              Vacation Bible School, all aimed at deepening their faith in a way that is
              fun and engaging. By integrating prayer, scripture memorization, and
              Biblical devotion, the Children’s Ministry seeks to raise up the next
              generation of believers who are not only grounded in their faith but also
              equipped to live out the Great Commission and make an impact for Christ in
              their homes, schools, and communities.
            </p>

            <img
              v-lazy="'img/ministries/children-ministry.JPG'"
              class="img-fluid rounded shadow mt-4"
              alt="Children's Ministry"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Music Ministry -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Music Ministry</h2>
            <p class="lead">
              The Music Ministry of One Body Christian Ministries (OBCM) Sta. Ana exists
              to exalt Jesus Christ and proclaim His Gospel through Christ-centered
              worship. Its primary mission is not performance but service—to lead the
              congregation in singing biblical truths that reflect God’s glory and point
              hearts to the saving work of Jesus.
            </p>

            <p class="lead">
              Every Sunday Worship Service is an opportunity to direct attention away from
              self and toward the cross, using music to support the preaching of the Word.
              During Prayer Meetings, the ministry leads in reverent songs that prepare
              hearts for intercession. In outreach efforts, the Music Ministry proclaims
              the Good News through songs that articulate the message of salvation to the
              community.
            </p>

            <p class="lead">
              Special events like Conforming to Christ Family Camp, Christmas carolling,
              and evangelistic concerts are strategic Gospel opportunities, designed to
              reach the lost by singing of the incarnation, crucifixion, and resurrection
              of Christ. These are not mere performances, but acts of worship and witness.
            </p>

            <p class="lead">
              The Music Ministry also supports the pastoral work and church missions,
              providing musical support for teaching corporate worship, evangelism, and
              discipleship. Every voice and instrument is offered in service to the
              mission of making disciples and spreading the Gospel to the glory of God
              alone.
            </p>

            <img
              v-lazy="'img/ministries/music-ministry.JPG'"
              class="img-fluid rounded shadow mt-4"
              alt="Music Ministry"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- C2C -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Conforming to Christ (C2C) Ministry</h2>
            <p class="lead">
              Conforming to Christ (C2C) is a ministry that began in 2002 with a mission
              to disciple and equip young people to live lives conformed to the image of
              Christ. This provides a space for youth to grow in their faith, create
              gospel partnerships, and commit to living a life worthy of the gospel.
            </p>

            <p class="lead">
              At present, by the sustaining grace of God, the C2C camp gathers annually to
              edify the whole church for 3 days of worshipping, praying, and hearing the
              Word together. The C2C continues to shape the next generation and the church
              to greater affection for Jesus Christ, for the glory of God.
            </p>

            <img
              v-lazy="'img/ministries/c2c-2025.JPG'"
              class="img-fluid rounded shadow mt-4"
              alt="Sports Fest 2024"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Sports Fest -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Sports Fest</h2>
            <p class="lead">
              OBCM Sportsfest is a ministerial event envisioned to bring the church
              community together through friendly sports competition and fellowship. It is
              an annual association-wide program featuring a variety of team and
              individual sports that encourages unity, sportsmanship, and gospel
              partnerships -- all grounded in faith and unity in the Word. It's a whole
              day program where the church celebrates the joy of community in Christ as we
              cheer each other and play together.
            </p>

            <img
              v-lazy="'img/ministries/sports-fest.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Sports Fest 2024"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Other Ministries -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Other Ministries</h2>

            <!-- Food Service Thru Pantry Ministry -->
            <br />
            <div>
              <p class="lead">
                <strong>Food Service Thru Pantry Ministry</strong>
              </p>
              <p>
                This ministry endeavours to glorify God through food service. A group of
                women and few young girls offer their time and dedication to manage and
                serve the food refreshment of congregation during Sunday school as well as
                special occasions.
              </p>
              <p>
                Part of this service is to take care of housekeeping and maintenance of
                utensils & wares and their repositories in order to make them well kept
                and properly maintained.
              </p>
              <p>
                The kind of service this ministry gives is wrapped with love and
                hospitality that makes everyone feel nourished and satisfied.
              </p>
              <p>
                1 Peter 4:10
                <i
                  >"As each one has received a special gift, employ it in serving one
                  another as good stewards of the multifaceted grace of God."</i
                >.
              </p>
              <img
                v-lazy="'img/ministries/pantry-ministry.JPG'"
                class="img-fluid rounded shadow mt-4"
                alt="Pantry Ministry"
              />
            </div>

            <!-- Online Saturday Bible Study -->
            <br />
            <div>
              <p class="lead">
                <strong>Online Saturday Bible Study</strong>
              </p>
              <p>
                During the challenges of the COVID-19 pandemic, the OBCM Saturday Bible
                Study Group emerged as a beacon of connection, faith, and learning.
                Initially created as an online gathering, the group was formed to serve
                neighbors in Las Pin̈as City (both new Christians and non-believers) and
                fellow church members based in the South Metro, providing a space for
                spiritual reflection and discussion at a time when physical gatherings
                were restricted.
              </p>
              <p>
                As people heared about the group’s engaging discussions and scriptural
                insights, interest grew beyond the South Metro community. Soon others
                sought to join. Despite being separated by distance, members remained
                united in their commitment to studying God's word, fostering meaningful
                connections, and supporting one another through prayer and shared wisdom.
              </p>
              <p>
                Each session focuses on a specific biblical topic strengthened by
                scripture references that guide discussions. Learners actively
                participate, sharing their interpretations, questions, and personal
                reflections. Through these conversations, members deepen their
                understanding of the Bible, apply its teachings to daily life, and
                strengthen their faith.
              </p>
              <p>
                From humble beginnings as a local initiative to an expanded faith
                community, the Saturday Bible Study Group stands as a testament to how
                shared devotion and learning can transcend boundaries, bringing people
                together in faith. It continues to provide an enriching and welcoming
                space where individuals can grow spiritually, support one another, and
                walk their journey of faith side by side.
              </p>

              <img
                v-lazy="'img/ministries/online-saturday-bible-study.JPG'"
                class="img-fluid rounded shadow mt-4"
                alt="Online Saturday Bible Study"
              />
            </div>

            <!-- Decoration Ministry -->
            <br />
            <div>
              <p class="lead">
                <strong>Decoration Ministry</strong>
              </p>
              <p>
                We are truly grateful to have brothers and sisters in Christ gifted and
                devoted individuals in our church who generously use their God-given
                talents to design and craft beautiful altar decorations. Their selfless
                dedication is a heartfelt expression of their service to God, blessing
                others through the beauty of their work. They are also called upon to
                enhance and adorn special ministry events, bringing creativity and grace
                to every occasion.
              </p>

              <img
                v-lazy="'img/ministries/decoration-ministry.jpg'"
                class="img-fluid rounded shadow mt-4"
                alt="Decoration Ministry"
              />
            </div>

            <!-- Gift Giving -->
            <br />
            <div>
              <p class="lead">
                <strong>Gift Giving</strong>
              </p>
              <p>
                Every year, as Christmas approaches, the One Body Christian Ministries
                continues its mission to bring light, love and hope to those who need it
                most. The Annual Christmas Gift-Giving is more than just an event – it’s a
                reflection of God’s boundless grace, made tangible through acts of
                compassion and generosity.
              </p>
              <p>
                Thanks to the unwavering support of partner private companies and
                kind-hearted individuals and church members, this charitable event serves
                as a conduit of God’s blessings. Groceries, warm meals, toiletries, basic
                medicines and vitamins, pre-loved yet comfortable clothing and shoes are
                gathered, repacked and lovingly distributed to families in need especially
                those hit-hard by calamities or living in underserved communities.
              </p>
              <p>
                While these gifts offer practical relief, it’s the message behind them
                that truly uplifts: that no one is forgotten, and that the love of Christ
                shines brightest when we serve one another. It is our collective prayer
                that each gift shared delivers not just momentary comfort, but a lasting
                reminder of hope in Christ.
              </p>
              <p>
                As OBCM celebrate the birth of our Savior, this ministry would continue to
                be a vessel of kindness and a source of joy reaching every heart, family
                and home with the true spirit of Christmas.
              </p>

              <img
                v-lazy="'img/ministries/gift-giving-2.jpg'"
                class="img-fluid rounded shadow mt-4"
                alt="Gift Giving"
              />
            </div>

            <!-- Medical Mission -->
            <br />
            <div>
              <p class="lead">
                <strong>Medical Mission</strong>
              </p>
              <p>
                Guided by Christ’s example of compassionate healing, the One Body
                Christian Ministries(OBCM) has, over the years, conducted a powerful
                ministry outreach that merges physical care with spiritual renewal.
                Through a series of medical-dental-optical missions across Northern and
                Southern Luzon, OBCM have embraced the call to bring the Gospel to
                communities in need – both in word and in action.
              </p>
              <p>
                This ministry is a collaborative effort, rooted in faith and compassion,
                and made possible through the partnership of medical volunteers from
                Canada and the USA, generous donors from Philippine pharmaceutical
                companies, and committed Christian workers with medical backgrounds.
                Together, OBCM Medical Team form a unified body – each bringing their
                God-given gifts to serve those who often go unseen like low-income
                families and marginalized communities who have little or no access at all
                to government healthcare services. These missions provide free medical
                consultations and dental and optical checkups, distribution of
                multi-vitamins and overthe-counter medications as well as first aid, minor
                surgical procedures and referrals to specialist and hospitals.
              </p>
              <p>
                But more than just healing bodies, this ministry is a vessel for healing
                hearts. Every consultation is an opportunity to share the love of Christ.
                Each act of care opens a door to proclaim the Gospel Message – that Christ
                sees, knows and cares deeply for every soul. As OBCM Medical Ministry
                continue to serve, our prayer is that many will come not only to receive
                physical aid but to encounter the Great Physician who offers eternal life
                and unshakable hope.
              </p>

              <img
                v-lazy="'img/ministries/medical-mission.jpg'"
                class="img-fluid rounded shadow mt-4"
                alt="Medical Mission"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "our-ministries",
  components: {},
};
</script>

<style scoped></style>
